import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {hideModal} from "../../../../store/actions/modals";
import {getActiveModal} from "../../../../store/reducers/modal";
import {CSSTransition} from 'react-transition-group';
import Button from "../../../common/ui/button/Button";
import {cloneElement} from 'react';

interface ModalComponentProps
{
    subtype?: string;
    modal_id: string;
    active_modal_id: string;
    children: JSX.Element;
    close_button_text?: string;
    close_button_type?: string;
    onClose?: () => void;
    close: () => void;
}

interface State
{
    visible: boolean;
}

import * as styles from './ModalComponent.scss';

class ModalComponent extends React.Component<ModalComponentProps, State>
{
    constructor(public props: ModalComponentProps, public state: State)
    {
        super(props);

        this.state = { visible: false };
    }


    onEntered = () =>
    {
        this.setState({ visible: true });
    };


    onExited = () =>
    {
        this.setState({ visible: false });
    };


    getStyleName = () =>
    {
        const {subtype} = this.props;

        switch (subtype)
        {
            case 'transparent':

                return 'transparent-container';

            default:

                return 'container';
        }
    };


    /**
     * when the close button is clicked
     */
    onClose = () =>
    {
        if (this.props.onClose) this.props.onClose();

        this.props.close();
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {close_button_type='ok', close_button_text='ok'} = this.props;
        const {visible} = this.state;

        // if (this.props.modal_id !== this.props.active_modal_id) return null;

        return <CSSTransition
                    in={this.props.modal_id === this.props.active_modal_id}
                    timeout={500}
                    classNames={{
                        enter: styles.containerEnter,
                        enterActive: styles.containerEnterActive,
                        exit: styles.containerExit,
                        exitActive: styles.containerExitActive,
                    }}
                    onEntered={this.onEntered}
                    onExited={this.onExited}
                    appear
                    unmountOnExit>

            <div
                styleName={this.getStyleName()}>

                <CSSTransition
                    in={visible}
                    timeout={500}
                    classNames={{
                        enter: styles.modalEnter,
                        enterActive: styles.modalEnterActive,
                        exit: styles.modalExit,
                        exitActive: styles.modalExitActive,
                    }}
                    appear
                    unmountOnExit>

                    <div styleName={'modal'}>

                        <div styleName={'content'}>

                            {/*{this.props.children}*/}

                            {cloneElement(this.props.children, { onClose: this.onClose}) }

                        </div>

                        {close_button_type !== 'none' &&
                        <div styleName={'footer'}>

                            <Button
                                type={close_button_type}
                                onClick={this.onClose}>{close_button_text}</Button>

                        </div>}

                    </div>

                </CSSTransition>

            </div>

        </CSSTransition>
    }
}



/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {
        active_modal_id: getActiveModal(state),
    }
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {
        close: () => dispatch(hideModal())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalComponent);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/ModalComponent.tsx